import React from "react";
import { Card, CardBody, CardHeader } from "@heroui/card";
import { Logo } from "../Logo/Logo";
import { UilExclamationOctagon } from "@iconscout/react-unicons";

export const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md mx-auto">
        <div className="mb-8 flex justify-center">
          <Logo />
        </div>

        <Card className="bg-gray-700/60 backdrop-blur-sm border border-gray-600/30 shadow-2xl rounded-3xl">
          <CardHeader className="pb-0 pt-8 px-8 flex justify-center">
            <div className="text-center space-y-4 w-full">
              <div className="flex justify-center">
                <div className="w-16 h-16 bg-gray-700/50 rounded-full flex items-center justify-center backdrop-blur-sm">
                  <UilExclamationOctagon size="32" color="#FBBF24" />
                </div>
              </div>
              <h1 className="text-2xl font-bold text-gray-400 tracking-tight">
                Page Not Found
              </h1>
            </div>
          </CardHeader>

          <CardBody className="px-8 py-8 flex justify-center">
            <div className="text-center w-full">
              <p className="text-gray-400 text-sm leading-relaxed max-w-sm mx-auto">
                The page you are looking for could not be found. Please check
                the URL and try again.
              </p>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};
